import { push } from 'connected-react-router';

export const suspend = store => async () => {
  console.log('suspend');
  store.dispatch(push('/driver/profile'));
};
